import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const SidebarShow20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M13.9696 9.96968L15.0303 11.0303L19.0606 7.00001L15.0303 2.96968L13.9696 4.03034L16.9393 7.00001L13.9696 9.96968Z'
      fill='currentColor'
    />
    <path d='M1 4.75001H11V3.25001H1V4.75001Z' fill='currentColor' />
    <path d='M1 10.75H11V9.25001H1V10.75Z' fill='currentColor' />
    <path d='M19 16.75H1V15.25H19V16.75Z' fill='currentColor' />
  </Svg>
);

SidebarShow20.displayName = 'SidebarShow20';
export default SidebarShow20;
